import { createSlice } from '@reduxjs/toolkit';
import { API } from 'api';

const initialState = {};

export const vehicleSlice = createSlice({
	name: 'vehicleState',
	initialState,
	reducers: {},
});

export const getVehicalList =
	({ search_type = '', currentPage, ...rest }) =>
	async () => {
		const CREDENTIALS = {
			url: '/search',
			data: {
				search_type,
				...rest,
			},
		};

		return API.common(CREDENTIALS).then((response) => ({
			rows: response?.data,
			count: response?.meta?.count,
		}));
	};

export default vehicleSlice.reducer;
